// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor[data-v-66ff47f0]{border:1px solid #ccc}.editor .editor-toolbar[data-v-66ff47f0]{border-bottom:1px solid #ccc}.editor .editor-content[data-v-66ff47f0]{height:500px;overflow-y:hidden}", ""]);
// Exports
module.exports = exports;
